import { Image, Text, View } from '@react-pdf/renderer';
import {
  AdproductsMoodysReportType,
  type CustomerAnalyticsMoodysReportDto,
} from '@zg-rentals/ts-customer-analytics-client';
import { MarketTrendsPageWrapper } from './MarketTrendsComponents';
import { styles } from './pdfStyles';
import { getReportNameString } from './CoverPage';

interface MarketMapPageProps {
  report: CustomerAnalyticsMoodysReportDto;
  marketMapImage: string;
  isPremium?: boolean;
}

export const MarketMapPage = ({ report, marketMapImage, isPremium }: MarketMapPageProps) => {
  const hasSubmarketData = report.reportType === AdproductsMoodysReportType.SUBMARKET;
  const marketReportString = getReportNameString({ isPremium, hasSubmarketData });

  return (
    <MarketTrendsPageWrapper quarter={report.dataAsOfQuarter} year={report.dataAsOfYear}>
      <Image src={marketMapImage} />
      <View
        style={{
          ...styles.containerBase,
          backgroundColor: 'white',
          color: '#0C4599',
          flexGrow: 2,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <View>
          <View
            style={{
              border: '2px solid #0C4599',
              padding: '5px',
              borderRadius: '30px',
              width: '230px',
            }}
          >
            <Text style={{ fontFamily: 'OpenSans', fontSize: 12, textAlign: 'center' }}>{marketReportString}</Text>
          </View>
          <Text style={{ fontFamily: 'OpenSansBold', fontSize: 30 }}>
            {hasSubmarketData ? report.submarketName : report.marketName}
          </Text>
        </View>
      </View>
    </MarketTrendsPageWrapper>
  );
};
